import IApplicationState from 'app/types/state';

export function getCurrentBankAccount(state: IApplicationState) {
  if (
    state.bankAccounts.bankAccountsById !== undefined
    && state.bankAccounts.currentBankAccountId === undefined
  ) {
    return state.bankAccounts.bankAccountsById[Object.keys(state.bankAccounts.bankAccountsById)[0]];
  }
  if (
    state.bankAccounts.bankAccountsById !== undefined
     && state.bankAccounts.currentBankAccountId !== undefined
  ) {
    return state.bankAccounts.bankAccountsById[
      state.bankAccounts.currentBankAccountId
    ];
  }
  return {};
}

export function getCurrentFormBankAccount(state: IApplicationState) {
  return {
    ...getCurrentBankAccount(state),
    ...state.bankAccounts.requestedData,
  };
}

export function getBankAccounts(state: IApplicationState) {
  return {
    ...state.bankAccounts,
    currentBankAccount: {
      ...getCurrentBankAccount(state),
    },
  };
}
